import {
  observable, computed, toJS, observe
} from 'mobx'
import Model from '../shared/model'

import validate from '../shared/decorators/model/validate'

import ACService from '../auth/acservice'

import { validations, additionalValidators, validationTexts } from './helpers'

@validate(validations, additionalValidators, validationTexts)
export default class User extends Model {

  @observable districtId = ''

  @observable address = ''

  @observable firstname = ''

  @observable surname = ''

  @observable email = ''

  @observable identification = {
    login: ''
  }

  @observable museum = {}

  @observable permissions = {}

  @observable group = null

  constructor(...args) {
    super(...args)
    this.autoSave = false
    this.initValidate()

    // force revalidation once the group changes to ensure validator
    // "hasMuseumName" is executed
    observe(this, 'group', () => {
      this.validate()
    })
  }

  set(...args) {
    const retval = super.set(...args)
    if (!this.acs) {
      this.acs = ACService.create({})
    }
    this.acs.setPermissions(this.permissions)

    return retval
  }

  parse(data, opts) {
    if (Array.isArray(data.identification)) {
      data.identification = data.identification[0] || {}
    }

    // in case the new data came from the server
    if (opts.synced) {
      data.origLogin = data.identification.login
    }

    return data
  }

  @computed get name() {
    return `${this.firstname} ${this.surname}`
  }

  /* eslint-disable complexity */
  @computed get asJSON() {

    const museum = toJS(this.museum)
    const identification = toJS(this.identification)

    const museumInfo = {}

    if (museum) {
      museumInfo.museum = typeof museum === 'string'
        ? {
          name: museum,
          id: this.museumId
        }
        : museum
      museumInfo.museumId = museum ? (museum.id || this.museumId || null) : null
    }

    let districtId
    let groups

    // those values are immutable after the entry was created
    if (!this.id) {
      districtId = this.districtId
      groups = [toJS(this.group)]
    }

    return {
      id: this.id,
      groups,
      permissions: this.permissions,
      districtId,
      address: this.address,
      firstname: this.firstname,
      surname: this.surname,
      email: this.email,
      identificationId: identification ? (identification.id || null) : null,
      identification,
      ...museumInfo
    }

  }
  /* eslint-enable complexity */

  getJSON() {
    return this.asJSON
  }

}



// WEBPACK FOOTER //
// ./src/user/model.js